import { render, staticRenderFns } from "./PlayBar.vue?vue&type=template&id=2a701903&scoped=true&"
import script from "./PlayBar.vue?vue&type=script&lang=js&"
export * from "./PlayBar.vue?vue&type=script&lang=js&"
import style0 from "./PlayBar.vue?vue&type=style&index=0&id=2a701903&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a701903",
  null
  
)

export default component.exports